//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';


interface Cafe {
  id: number;
  cafename: string;
  cafecode: any;
  sitecode?: string;
}


interface Site {
  id: number;
  sitename: string;
  sitealias?: string;
  siteid: string;
  sitecode: any
}


interface SiteState {
  cafes: Cafe[];
  sites: Site[];
  regionsites: Site[];
  loading: boolean;
  error: string | null;
}


const initialState: SiteState = {
  cafes: [],
  sites: [],
  regionsites: [],
  loading: false,
  error: null,
};
interface FetchRegionSitesPayload {
  userId: string;
  regionid: string;       // or string, if your regionid is truly a string
  sectorcode: string;
}
const roleid = Number(localStorage.getItem('roleId'));

// Async Thunks
export const fetchCafes = createAsyncThunk('site/fetchCafes', async (userId: string | null) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/api/v1/Cafe/GetCafeByUserId`,
      { userid: userId }
    );


    const data = response.data;
    if (!data.success) {
      throw new Error(data.errormessage || 'Failed to fetch cafes');
    }


    return data.data.cafes;


  } catch (error: any) {
    throw new Error(error.response?.data?.errormessage || 'Failed to fetch cafes');
  }
});

export const fetchSites = createAsyncThunk('site/fetchSites', async (userId: string | null) => {
  try {

    const response = await axiosInstance.post(
      `${BASE_URL}/api/v1/Site/GetSitesByUserId`,
      { userid: userId }
    );


    const data = response.data;
    if (!data.success) {
      throw new Error(data.errormessage || 'Failed to fetch sites');
    }


    return data.data.sites;
  } catch (error: any) {
    throw new Error(error.response?.data?.errormessage || 'Failed to fetch sites');
  }
});

export const fetchRegionSites = createAsyncThunk(
  "site/fetchRegionSites",
  // "payload" is your single object with multiple fields
  async (payload: FetchRegionSitesPayload) => {
    try {
      const { userId, regionid, sectorcode } = payload;

      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/AdminConfiguration/GetAllSites`,
        { userid: userId, regionid, sectorcode, roleid: roleid }
      );

      const data = response.data;
      if (!data.success) {
        throw new Error(data.errormessage || "Failed to fetch sites");
      }

      return data.data.sitelist; // returned value will become `action.payload`
    } catch (error: any) {
      throw new Error(
        error.response?.data?.errormessage || "Failed to fetch sites"
      );
    }
  }
);

export const fetchRegionDashboardSites = createAsyncThunk(
  "site/fetchRegionDashboardSites",
  // "payload" is your single object with multiple fields
  async (payload: FetchRegionSitesPayload) => {
    try {
      const { userId, regionid, sectorcode } = payload;

      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/AdminConfiguration/GetAllSitesByRegion`,
        { userid: userId, regionid, sectorcode, roleid: roleid }
      );

      const data = response.data;
      if (!data.success) {
        throw new Error(data.errormessage || "Failed to fetch sites");
      }

      return data.data.sitelist; // returned value will become `action.payload`
    } catch (error: any) {
      throw new Error(
        error.response?.data?.errormessage || "Failed to fetch sites"
      );
    }
  }
);

// Slice
const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCafes.fulfilled, (state, action) => {
        state.cafes = action.payload;
        state.loading = false;
      })
      .addCase(fetchCafes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.sites = action.payload;
        state.loading = false;
      })
      .addCase(fetchRegionSites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRegionSites.fulfilled, (state, action) => {
        state.regionsites = action.payload;
        state.loading = false;
      })
      .addCase(fetchRegionDashboardSites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRegionDashboardSites.fulfilled, (state, action) => {
        state.regionsites = action.payload;
        state.loading = false;
      });

  },
});


export default siteSlice.reducer;



